"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const opportunity_1 = require("./opportunity");
const enums_1 = require("../../../@shared-types/opportunites/enums");
let OpportunintyStateFormComponent = class OpportunintyStateFormComponent {
    constructor(opportunityModel) {
        this.opportunityModel = opportunityModel;
        this.data = { title: '' };
        this.updateData = {
            stateReason: '',
            postponeDate: null,
        };
        this.updateState = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.opportunity.id)
                return;
            yield this.opportunityModel.update(this.opportunity.id, Object.assign(Object.assign({}, this.updateData), { state: this.state }));
            this.exit(true);
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.state) {
                case enums_1.EOpportunityState.CLOSED:
                    this.data.title = 'Verkaufschance schließen';
                    break;
                case enums_1.EOpportunityState.POSTPONED:
                    this.data.title = 'Verkaufschance zurückstellen';
                    break;
                case enums_1.EOpportunityState.OPEN:
                    this.data.title = 'Verkaufschance öffnen';
                    break;
                default: break;
            }
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], OpportunintyStateFormComponent.prototype, "opportunity", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], OpportunintyStateFormComponent.prototype, "exit", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_a = typeof enums_1.EOpportunityState !== "undefined" && enums_1.EOpportunityState) === "function" ? _a : Object)
], OpportunintyStateFormComponent.prototype, "state", void 0);
OpportunintyStateFormComponent = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-state-form',
        template: /* html */ `
  <side-sheet [title]="data.title" [exit]="exit">
    <form class="default-form" (ngSubmit)="updateState()" id="stateForm">
      <div class="row">
        <ab-datepicker
          [(selectedDate)]="updateData.postponeDate"
          returnType='Date'
          [placeholder]="'Zurückstellen bis'"
          class="col-md-12 px-0"
          *ngIf="state === 'P'"
        ></ab-datepicker>
      </div>

      <div class="row">
        <div class="input-wrap col-md-12">
          <textarea name="stateReason"
            [(ngModel)]="updateData.stateReason"
            placeholder="Grund" required rows="3"></textarea>
          <label for="stateReason">Grund</label>
        </div>
      </div>
    </form>

    <button
      actions
      form="stateForm"
      type="submit"
      class="btn-lvl1"
      ng-class="{'btn-sending': survey.sending}"
      ng-disabled="survey.sending"
    >Verkaufschance speichern</button>
  </side-sheet>
  `,
    }),
    __metadata("design:paramtypes", [typeof (_b = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _b : Object])
], OpportunintyStateFormComponent);
exports.default = OpportunintyStateFormComponent;
